/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Helmet from 'react-helmet';
/* eslint-enable import/no-extraneous-dependencies */

import Home from '../pageComponents/home';

export default () => ([
  <Helmet key="homeHelmet" title="YesWeAreTwins" />,
  <Home key="homePage" />,
]);



// WEBPACK FOOTER //
// ./src/pages/index.jsx